import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function ProtectedRouter({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Pure superusers (createsuperuser — no condominioId) land on / but should be in /admin
  const isSuperUser  = localStorage.getItem("is_superuser") === "true";
  const condominioId = localStorage.getItem("condominioId");
  if (isSuperUser && !condominioId && location.pathname === "/") {
    return <Navigate to="/admin" replace />;
  }

  // Residentes land on / but should be in /portal
  const rol = localStorage.getItem("rol");
  if (rol === "RESIDENTE" && !location.pathname.startsWith("/portal")) {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
